import { Capacitor } from '@capacitor/core';

/**
 * Returns the client platform for API headers
 * @returns 'android' for Capacitor Android, 'web' for browser
 */
export const getClientPlatform = (): 'android' | 'web' => {
  if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'android') {
    return 'android';
  }
  return 'web';
};